var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.loading
    ? _c(
        "div",
        { staticClass: "productContainer" },
        [
          _c("h2", {
            domProps: { innerHTML: _vm._s(_vm.productData[0].name) },
          }),
          _c("br"),
          _vm.productData.length > 1
            ? _c("p", { staticClass: "catHeader" }, [
                _vm._v(_vm._s(_vm.$root.language.wsm_chooseProduct)),
              ])
            : _vm._e(),
          _c(
            "div",
            { staticClass: "varients" },
            _vm._l(_vm.productData, function (product) {
              return _c(
                "div",
                {
                  key: product.productId,
                  staticClass: "variantItem",
                  class: {
                    activeChoice: product.productId == _vm.pickedVariant,
                    activeChoiceSub:
                      _vm.typeOfPurchase == "sub" &&
                      product.productId == _vm.pickedVariant,
                  },
                  on: {
                    click: function ($event) {
                      _vm.pickedVariant = product.productId
                    },
                  },
                },
                [
                  _c("div", { staticClass: "choiceContentContainer" }, [
                    _c(
                      "div",
                      { staticClass: "picked" },
                      [
                        _c(
                          "Transition",
                          {
                            attrs: {
                              name: "bounce",
                              duration: { enter: 500, leave: 0 },
                            },
                          },
                          [
                            product.productId == _vm.pickedVariant
                              ? _c(
                                  "svg",
                                  {
                                    class: {
                                      issubscriptionCheck:
                                        _vm.typeOfPurchase == "sub",
                                    },
                                    attrs: {
                                      xmlns: "http://www.w3.org/2000/svg",
                                      height: "1em",
                                      viewBox: "0 0 512 512",
                                    },
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        d: "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z",
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                        _c("div", { staticClass: "emptyField" }),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "choiceContent" }, [
                      _c("div", { staticClass: "typeOf" }, [
                        _vm._v(
                          _vm._s(
                            _vm.removeHtmlFromVariant(product.quantityString)
                          )
                        ),
                      ]),
                    ]),
                  ]),
                  product.promotionAttributes &&
                  product.promotionAttributes.length > 0
                    ? _c("PromotionLabel", {
                        attrs: { promotion: product.promotionAttributes },
                      })
                    : _vm._e(),
                ],
                1
              )
            }),
            0
          ),
          _vm.admin || (_vm.localadmin && !_vm.oldurl)
            ? _c("selectversion", {
                attrs: {
                  pickedProduct: _vm.pickedProduct,
                  pickedVariant: _vm.pickedVariant,
                },
              })
            : _vm._e(),
          _c("div", { staticClass: "singleOrSub" }, [
            _c(
              "div",
              {
                staticClass: "choiceContainer",
                class: { activeChoice: _vm.typeOfPurchase == "single" },
                on: {
                  click: function ($event) {
                    _vm.changeTypeOfPurchase(
                      "single",
                      _vm.typeOfPurchase != "single"
                    )
                  },
                },
              },
              [
                _c("div", { staticClass: "choiceContentContainer" }, [
                  _c(
                    "div",
                    { staticClass: "picked" },
                    [
                      _c(
                        "Transition",
                        {
                          attrs: {
                            name: "bounce",
                            duration: { enter: 500, leave: 0 },
                          },
                        },
                        [
                          _vm.typeOfPurchase == "single"
                            ? _c(
                                "svg",
                                {
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    height: "1em",
                                    viewBox: "0 0 512 512",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z",
                                    },
                                  }),
                                ]
                              )
                            : _vm._e(),
                        ]
                      ),
                      _c("div", { staticClass: "emptyField" }),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "choiceContent" }, [
                    _c("div", {
                      staticClass: "typeOf",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.pickedProduct.subscription_price
                            ? _vm.$root.language.wsm_sub_oneTimePurchase
                            : _vm.productData[0].name
                        ),
                      },
                    }),
                    _c("div", { staticClass: "choicePrice" }, [
                      _vm._v(
                        _vm._s(
                          _vm.getVisString({
                            price: _vm.pickedProduct.price,
                            currencyIso: _vm.pickedProduct.CurrencyIso,
                            precision: _vm.pickedProduct.currencyPrecision,
                          })
                        ) + " "
                      ),
                      (_vm.pickedProduct.discount > 0 || _vm.$root.iscompany) &&
                      !_vm.$root.pointshop
                        ? _c(
                            "p",
                            { staticClass: "discountYouSave" },
                            [
                              _c("additionalInfo", {
                                attrs: {
                                  data: _vm.pickedProduct,
                                  tax: _vm.pickedProduct.taxRateFactor,
                                  issubtype: false,
                                  showBuyButton: true,
                                  listPrice: _vm.getVisString({
                                    price: _vm.pickedProduct.listPrice,
                                    currencyIso: _vm.pickedProduct.CurrencyIso,
                                    precision:
                                      _vm.pickedProduct.currencyPrecision,
                                  }),
                                  localDiscount: _vm.getVisString({
                                    price: _vm.pickedProduct.discount,
                                    currencyIso: _vm.pickedProduct.CurrencyIso,
                                    precision:
                                      _vm.pickedProduct.currencyPrecision,
                                  }),
                                  companyPriceIncludingVat:
                                    _vm.pickedProduct.companyPriceIncludingVat,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                  ]),
                ]),
              ]
            ),
            _vm.pickedProduct.isAllowSubscription
              ? _c(
                  "div",
                  {
                    staticClass: "choiceContainer subContainer",
                    class: {
                      activeChoice: _vm.typeOfPurchase == "sub",
                      flash: _vm.flash,
                    },
                    on: {
                      click: function ($event) {
                        _vm.changeTypeOfPurchase(
                          "sub",
                          _vm.typeOfPurchase != "sub"
                        )
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "choiceContentContainer" }, [
                      _c(
                        "div",
                        { staticClass: "picked" },
                        [
                          _c(
                            "Transition",
                            {
                              attrs: {
                                name: "bounce",
                                duration: { enter: 500, leave: 0 },
                              },
                            },
                            [
                              _vm.typeOfPurchase == "sub"
                                ? _c(
                                    "svg",
                                    {
                                      attrs: {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        height: "1em",
                                        viewBox: "0 0 512 512",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d: "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z",
                                        },
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                          _c("div", { staticClass: "emptyField" }),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "choiceContent" }, [
                        _c("div", { staticClass: "typeOf" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$root.language.wsm_sub_subscriptionPurchase
                              ) +
                              " "
                          ),
                          _vm.pickedProduct.subscriptionDiscountPercentage > 0
                            ? _c("span", { staticClass: "subcta" }, [
                                _vm._v(_vm._s(_vm.subscriptionDiscountCTA)),
                              ])
                            : _vm._e(),
                        ]),
                        _c("div", { staticClass: "choicePrice" }, [
                          _vm._v(
                            _vm._s(
                              _vm.getVisString({
                                price: _vm.pickedProduct.subscription_price,
                                currencyIso: _vm.pickedProduct.CurrencyIso,
                                precision: _vm.pickedProduct.currencyPrecision,
                              })
                            ) +
                              " / " +
                              _vm._s(_vm.$root.language.wsm_Order) +
                              " "
                          ),
                          (_vm.pickedProduct.discount > 0 ||
                            this.$root.iscompany == 1 ||
                            _vm.pickedProduct.subscriptionDiscountPercentage >
                              0) &&
                          !_vm.$root.pointshop
                            ? _c(
                                "p",
                                { staticClass: "discountYouSave" },
                                [
                                  _c("additionalInfo", {
                                    attrs: {
                                      data: _vm.pickedProduct,
                                      tax: _vm.pickedProduct.taxRateFactor,
                                      issubtype: true,
                                      showBuyButton: true,
                                      listPrice: _vm.getVisString({
                                        price: _vm.pickedProduct.listPrice,
                                        currencyIso:
                                          _vm.pickedProduct.CurrencyIso,
                                        precision:
                                          _vm.pickedProduct.currencyPrecision,
                                      }),
                                      localDiscount: _vm.getVisString({
                                        price:
                                          _vm.pickedProduct
                                            .subscriptionDiscount,
                                        currencyIso:
                                          _vm.pickedProduct.CurrencyIso,
                                        precision:
                                          _vm.pickedProduct.currencyPrecision,
                                      }),
                                      companyPriceIncludingVat:
                                        _vm.pickedProduct
                                          .companyPriceIncludingVat,
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "extraOnPicked" }, [
                      (_vm.isSmallScreen && _vm.typeOfPurchase == "sub") ||
                      !_vm.isSmallScreen
                        ? _c("div", { staticClass: "subSettings" }, [
                            _c(
                              "p",
                              { staticStyle: { "font-weight": "bold" } },
                              [
                                _vm._v(
                                  _vm._s(_vm.$root.language.wsm_sub_interval)
                                ),
                              ]
                            ),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.pickedInterval,
                                    expression: "pickedInterval",
                                  },
                                ],
                                on: {
                                  change: function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.pickedInterval = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  },
                                },
                              },
                              _vm._l(_vm.intervals, function (interval) {
                                return _c(
                                  "option",
                                  { domProps: { value: interval.freqencyId } },
                                  [
                                    _vm._v(
                                      _vm._s(interval.name) +
                                        " " +
                                        _vm._s(
                                          interval.freqencyId ==
                                            _vm.pickedProduct
                                              .recommendedFrequencyId
                                            ? `(${_vm.$root.language.wsm_sub_recommendedInterval})`
                                            : ""
                                        )
                                    ),
                                  ]
                                )
                              }),
                              0
                            ),
                            _c("p", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$root.language.wsm_sub_info_widget_body
                                ),
                              },
                            }),
                            _c(
                              "p",
                              {
                                staticClass: "sub_info",
                                on: { click: _vm.showSubInfo },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    this.$root.language
                                      .wsm_sub_info_widget_btntext
                                  )
                                ),
                              ]
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ]
                )
              : _vm._e(),
          ]),
          _c(
            "div",
            { staticClass: "buyContainer" },
            [
              _c("buybuttonv2", {
                ref: "buybutton",
                attrs: { id: _vm.pickedProduct.productId },
                on: {
                  gtag: _vm.gtag,
                  changeTypeOfPurchase: _vm.changeTypeOfPurchase,
                },
              }),
            ],
            1
          ),
          _vm.showSubInfoModal
            ? _c("savewithsub", { on: { closesubinfo: _vm.closesubinfo } })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }